<script>
import store from '@state/store'
import { authComputed } from '@state/helpers'
import InitDateRange from '@reports/mixins/initDateRange.vue'
import DateRange from './dateRange.vue'

export default {
  components: {
    DateRange,
  },
  mixins: [InitDateRange],
  data() {
    return {
      events: [100, 150],
    }
  },
  computed: {
    ...authComputed,
    companyId() {
      return +this.$route.params.companyId
    },
  },
  mounted() {
    this.dataSettings = [
      {
        from: '',
        to: '',
        desc: 'This Year',
        colorClass: 'bg-blue-light',
      },
      {
        from: '',
        to: '',
        desc: 'Last Year',
        colorClass: 'bg-green-300',
      },
    ]
    // this.initLastTwoYearsData()
  },
  methods: {
    exportDataPoints() {
      // TODO: add API
    },
    fetchData(dateRange) {
      const params = {
        companyId: this.companyId,
        from: dateRange.from,
        to: dateRange.to,
      }

      store
        .dispatch('reports/fetchEventsReport', params)
        .then((result) => {
          this.dataSettings.push(dateRange)
        })
        .catch((err) => {
          alert(err.message || 'Something went wrong.')
        })
    },
  },
}
</script>

<template>
  <div>
    <!-- date range -->
    <div class="flex justify-between border-b border-gray pb-8 mb-8">
      <DateRange
        @add-data-points="addDataPoints"
        @export-data-points="exportDataPoints"
      />

      <ul>
        <li
          v-for="(setting, i) in dataSettings"
          :key="i"
          class="flex items-center mb-1"
        >
          <span
            :class="setting.colorClass"
            class="inline-block w-6 h-6 mr-3"
          ></span>
          <span class="font-bold text-basel">{{ setting.desc }}</span>
        </li>
      </ul>
    </div>

    <!-- Event -->
    <div class="border-b border-gray px-4 pb-8 mb-8">
      <!-- title -->
      <div class="flex font-bold text-basel mb-3">
        Events Held
      </div>
      <!-- data points -->
      <ul v-if="dataSettings.length" class="flex mb-2">
        <li class="w-1/4">
          <div
            v-for="(event, i) in events"
            :key="i"
            class="flex items-center mb-2"
          >
            <span class="mr-4 w-1/6">{{ event }}</span>
            <div
              :class="dataSettings[i].colorClass"
              class="h-8"
              :style="{
                width: `${(event / getMaxLength(events)) * 200}px`,
              }"
            />
          </div>
        </li>
      </ul>
    </div>

    <div
      class="font-bold text-2xl border-b border-gray pb-8 px-10 my-8 flex justify-around"
    >
      <div v-for="s in [0, 1, 2]" :key="s">
        <span class="text-gray">Total User Count: </span>
        <span class="text-blue-darker">247</span>
      </div>
    </div>

    <div
      class="font-bold text-2xl border-b border-gray pb-8 px-10 my-8 flex justify-around"
    >
      <div v-for="s in [0, 1, 2]" :key="s">
        <span class="text-gray">No Show Rate: </span>
        <span class="text-blue-darker">8.6%</span>
      </div>
    </div>
  </div>
</template>
